import _ from 'lodash';
import * as types from './types';

import httpService from '../_utils/http-service';
import { getAuthHttpConfig, getAuthHttpConfigByToken } from '../_utils/auth-utils';
import { traceEvent } from "../_utils/analytics-utils";

export const fetchFavoriteRestaurants = (customerId, token, callback) => {

    httpService.get(`/v2/customers/${customerId}/favorite/restaurants?serviceTypeId=1`,
        getAuthHttpConfigByToken(token)).then(res => {
           
            if (res.data.statusCode === 200) {
                const list = _.map(res.data.data, item => item.id);
                callback({ success: true, list });
            } else {
               
                callback({ success: false });
                traceEvent("error", "fetchFavoriteRestaurants");
            }
        }).catch(err => {
            callback({ success: false });
            traceEvent("error", "fetchFavoriteRestaurants");
        });
}


export const toggleFavoriteRestaurant = ({ profile, restaurantId }, callback) => {

    return function (dispatch, getState) {
        const storage = getState().storage;
        httpService.post(`/customers/${profile.customer.id}/restaurant/${restaurantId}/favorite/services/1`, null,
            getAuthHttpConfig(storage)).then(res => {

                if (res.data.statusCode === 201 ||
                    res.data.statusCode === 204
                ) {

                    fetchFavoriteRestaurants(profile.customer.id, storage.authToken, (res) => {
                        if (res.success === true) {
                            dispatch({
                                type: types.SET_ITEM, payload: {
                                    key: 'favorites',
                                    value: res.list
                                }
                            });

                            callback({ success: true });
                        } else {
                            callback({ success: false });
                        }
                    })

                } else {
                    callback({ success: false });
                }
            }).catch(err => {
                callback({ success: false });
            });
    }
}
